export default __webpack_public_path__ + "static/media/sound.2e7f23c8.mp3";